export enum SourceType {
    searchEntity = 'searchEntity',
}
